import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";

function Footer() {
  return (
    <footer className="bg-blue-600 text-white text-center py-8">
      <p>&copy; {new Date().getFullYear()} Indangalasia Lightstar Academy. All Rights Reserved.</p>
      <div className="flex justify-center mt-4 space-x-6">
          <a href="#" className="text-white hover:opacity-80">
            <FaFacebookF size={24} />
          </a>
          <a href="#" className="text-white hover:opacity-80">
            <FaTwitter size={24} />
          </a>
          <a href="#" className="text-white hover:opacity-80">
            <FaInstagram size={24} />
          </a>
      </div>
      <p className="mt-4">
        Developed by <a href="https://pixelpulse-hub.vercel.app" style={{ color: "#F1B740" }} className="hover:underline">PixelPulse Hub</a>
      </p>
    </footer>
  );
}

export default Footer;
